/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_FailedInputs */

const en_us2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That didn't work. Try again.`)
};

const pt_br2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu certo. Tente de novo.`)
};

const es_419_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No funcionó. Inténtalo de nuevo.`)
};

const pt_pt2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não resultou. Tenta outra vez.`)
};

const fr_fr2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça n'a pas marché. Réessaie.`)
};

const de_de2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt. Versuch es noch mal.`)
};

const it_it2_clubs_failed = /** @type {(inputs: Clubs_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ha funzionato. Riprova.`)
};

/**
* | output |
* | --- |
* | "That didn't work. Try again." |
*
* @param {Clubs_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_failed = /** @type {((inputs?: Clubs_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_failed(inputs)
	if (locale === "es-419") return es_419_clubs_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_failed(inputs)
	if (locale === "de-DE") return de_de2_clubs_failed(inputs)
	if (locale === "it-IT") return it_it2_clubs_failed(inputs)
	return en_us2_clubs_failed(inputs)
});
export { clubs_failed as "clubs.failed" }